import dayjs from "dayjs"
import { useHost } from "../global/host.global"
import { useCurrentDepartment } from "./useAuth"
import qs from "query-string"

const useLink = () => {
  const depId = useCurrentDepartment()
  const { subdomain } = useHost()
  function redirect(link: string, parameters: any, self?: boolean) {
    const params = {
      dep: depId,
      tenant: subdomain,
      ...parameters,
      ...(parameters.date && {
        date: dayjs(parameters.date).format("DDMMYYYY"),
      }),
    }
    const queryString = qs.stringify(params, { arrayFormat: "comma" })
    // Encode the query string to avoid revealing sensitive information
    const encodedString = btoa(queryString)

    if (self) {
      window.open(`${link}${encodedString}`, "_parent")
    } else {
      window.open(`${link}${encodedString}`, "__blank")
    }
  }
  return redirect
}

export default useLink
